function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.3 6.3c0-.1.2-.3.4-.3h.7c.2 0 .3.2.3.3V11q0 .3-.3.3h-.7q-.3 0-.3-.3V6.3zm0 6.7q0-.3.3-.3h.7q.3 0 .3.3v.7q0 .3-.3.3h-.6q-.3 0-.3-.3V13zm8.7 2.5L8.3.2c-.1-.2-.5-.2-.6 0L0 15.5c-.1.2.1.5.3.5h15.3c.3 0 .5-.3.4-.5",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "&quot"
    }
  }));
};
export default SvgWarning;